"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentProviderResult = exports.PaymentProviderType = void 0;
var PaymentProviderType;
(function (PaymentProviderType) {
    PaymentProviderType[PaymentProviderType["None"] = -1] = "None";
    /**  The Adyen payment provider. https://docs.adyen.com/online-payments */
    PaymentProviderType[PaymentProviderType["Adyen"] = 0] = "Adyen";
    /** The External payment providers. */
    PaymentProviderType[PaymentProviderType["External"] = 1] = "External";
    /** The Surfboard payment provider. https://developers.surfboardpayments.com/ */
    PaymentProviderType[PaymentProviderType["Surfboard"] = 2] = "Surfboard";
})(PaymentProviderType = exports.PaymentProviderType || (exports.PaymentProviderType = {}));
var PaymentProviderResult;
(function (PaymentProviderResult) {
    PaymentProviderResult[PaymentProviderResult["Completed"] = 0] = "Completed";
    PaymentProviderResult[PaymentProviderResult["ActionRequired"] = 1] = "ActionRequired";
    PaymentProviderResult[PaymentProviderResult["Refused"] = 2] = "Refused";
    PaymentProviderResult[PaymentProviderResult["Received"] = 3] = "Received";
})(PaymentProviderResult = exports.PaymentProviderResult || (exports.PaymentProviderResult = {}));
